export type HouseholdRouteSegment = "clients" | "prospects" | "past-clients"

export function householdRouteSegment(type: string): HouseholdRouteSegment {
  if (type === "Client") return "clients"
  if (type === "PastClient") return "past-clients"
  return "prospects"
}
